var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.activityReports),function(report){return _c('div',{key:report.id},[(report.id === _vm.$route.params.id)?_c('div',[_c('BaseFileViewer',{attrs:{"title":report.original_name,"fileUrl":report.report_file_url,"dialog":true,"type":report.extension},on:{"input":function($event){return _vm.onClose($event)}}})],1):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }